export const QUERY_KEYS = {
  players: (userId?: string) => ['players', userId] as const,
  player: (playerId?: string) => ['player', playerId] as const,
  sessions: (userId?: string) => ['sessions', userId] as const,
  session: (sessionId?: string) => ['session', sessionId] as const,
  expenses: (userId?: string) => ['expenses', userId] as const,
  userSettings: (userId?: string) => ['user-settings', userId] as const,
  allSessionPlayers: (userId?: string) => ['session-players', 'all', userId] as const,
  sessionResults: (sessionId?: string) => ['session-players', 'results', sessionId] as const,
  sessionTemplates: (userId?: string) => ['session-templates', userId] as const,
};
